export const addLoader = (target: HTMLElement) => {
  const spinnerId = 'xund-spinner'
  const styleId = 'xund-spinner-style'

  const existingLoadingEl = document.getElementById(spinnerId)
  const existingStyleEl = document.getElementById(styleId)

  const element = existingLoadingEl === null ? document.createElement('div') : document.getElementById(spinnerId)

  if (!element) {
    return
  }

  element.id = spinnerId
  element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><circle cx="38" cy="24" r="4" fill="#D9D9D9"/><circle cx="10" cy="24" r="4" fill="#D9D9D9"/><circle cx="24" cy="24" r="4" fill="#BBBBBB"/></svg>`

  if (!existingStyleEl) {
    document.head.insertAdjacentHTML(
      'beforeend',
      `
        <style id="${styleId}">
          #${'xund-app'} { width: 100%; height: 100%; border: none; font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Avenir Next', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; }
          #xund-spinner,#spinner,#error { display:flex; justify-content: center; align-items: center; height: 100vh; width: 100%; }
          #error{ flex-direction: column; position: absolute; top:0; left:0; width: 100%; height: 100%; z-index: 1; }
          #error-container { padding:1em; width:400px; background-color:#E5EDF4 }
          #error h1{ color:#ff6666; font-size: 1.0em;margin-bottom:0.3em}
          #error p{ display: block; margin-top:0}
          #xund-spinner svg circle,#spinner svg circle { animation-duration: 0.9s; animation-iteration-count: infinite; animation-timing-function: ease-out; }
          #xund-spinner svg circle:nth-child(1),#spinner svg circle:nth-child(1) { animation-name: spinner-hl; }
          #xund-spinner svg circle:nth-child(2),#spinner svg circle:nth-child(2) { animation-name: spinner-hr; }
          #xund-spinner svg circle:nth-child(3),#spinner svg circle:nth-child(3) { animation-name: spinner-v; animation-duration: 1.8s; }
          @keyframes spinner-v {
            0%, 50%, 100% {transform: translateY(0)}
            25% {transform: translateY(-20px)}
            75% {transform: translateY(20px)} 
          }
          @keyframes spinner-hl {
            0%, 100% {transform: translateX(0)}
            50% {transform: translateX(-14px)}
          }
          @keyframes spinner-hr {
            0%, 100% {transform: translateX(0)}
            50% {transform: translateX(14px)}
          }
        </style>
      `,
    )
  }

  if (!existingLoadingEl && target.parentNode) {
    target.appendChild(element)
  }
  return element
}
